(() => {
  const selector = '.tpl-mobile-opening,.tpl-na__hero,.tpl-women__campaign,.tpl-curated__campaign,.tpl-club-collection__campaign,.tpl-journal-cover,.tpl-ecover,.tpl-editorial-product__hero,.tpl-me__cover';
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  let cleanup = () => {};
  const setup = () => {
    cleanup();
    const cover = [...document.querySelectorAll('#MainContent ' + selector.split(',').join(',#MainContent '))].find(el => {
      const box = el.getBoundingClientRect();
      return box.height > 220 && box.width > 0 && box.top < innerHeight && box.bottom > 0;
    });
    if (!cover || cover.querySelector('[data-tpl-opening-shop]') || window.scrollY > 40) return;
    const image = cover.querySelector('img,video');
    if (!image) return;
    // Anchor covers cannot contain another interactive element.
    const host = cover.matches('a') ? cover.parentElement : cover;
    const previousPosition = host.style.position;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'tpl-cover-invitation';
    button.setAttribute('aria-label', document.querySelector('[data-tpl-cover-invitation]')?.dataset.label || 'Explore below');
    button.innerHTML = '<span aria-hidden="true"></span>';
    host.append(button);
    const controller = new AbortController(), signal = controller.signal;
    let dismissed = false;
    const dismiss = () => { dismissed = true; button.classList.remove('is-inviting'); button.classList.add('is-dismissed'); button.tabIndex = -1; };
    const observer = new IntersectionObserver(entries => {
      if (!dismissed && entries[0].isIntersecting && !reduced.matches) button.classList.add('is-inviting');
    }, {threshold:.5});
    observer.observe(cover);
    button.addEventListener('click', () => {
      const header = document.getElementById('TplStickyHeader')?.getBoundingClientRect().height || 0;
      const top = window.scrollY + cover.getBoundingClientRect().bottom - header;
      window.scrollTo({top, behavior:reduced.matches ? 'auto' : 'smooth'});
      dismiss();
    }, {signal});
    window.addEventListener('scroll', () => { if (window.scrollY > 40) dismiss(); }, {passive:true,signal});
    window.addEventListener('wheel', dismiss, {passive:true,once:true,signal});
    window.addEventListener('touchmove', dismiss, {passive:true,once:true,signal});
    window.addEventListener('keydown', event => { if (['ArrowDown','PageDown','End',' '].includes(event.key)) dismiss(); }, {signal});
    reduced.addEventListener('change', () => { if (reduced.matches) button.classList.remove('is-inviting'); }, {signal});
    cleanup = () => { controller.abort(); observer.disconnect(); button.remove(); host.style.position = previousPosition; };
  };
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('tpl:product:changed', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
